import { Col, Divider, Row, Space } from "antd";
import { FormInput } from "components/form/FormProvide";
import { useTranslation } from "react-i18next";
import styles from "../ContactInfo/ContactInfo.module.css";

import FB from "assets/logo/facebook.png";
import INSTA from "assets/logo/instagram.png";
import INTERNET from "assets/logo/internet.png";
import LINE from "assets/logo/line.png";
import TT from "assets/logo/tiktok.png";
import TWT from "assets/logo/twitter.png";

const SocialMediaInformationForEdit = () => {
    const { t } = useTranslation();
    return (
        <Space direction="vertical" size={6} style={{ width: "100%" }}>
            <b className={styles.infoTopic}>
                {t("company_profile.label.social_media_information")}
            </b>
            <Divider />
            <Row gutter={[24, 16]}>
                <Col span={12} className={styles.socialRow}>
                    <div className={styles.socialLogoContainer}>
                        <img className={styles.socialLogo} src={FB} alt="Facebook logo" />
                    </div>
                    <FormInput fontWeight="bold" vertical={true} name="facebook" placeholder="Facebook" size="large" />
                </Col>
                <Col span={12} className={styles.socialRow}>
                    <div className={styles.socialLogoContainer}>
                        <img className={styles.socialLogo} src={TWT} alt="x logo" />
                    </div>
                    <FormInput fontWeight="bold" vertical={true} name="x" placeholder="Twitter" size="large" />
                </Col>
                <Col span={12} className={styles.socialRow}>
                    <div className={styles.socialLogoContainer}>
                        <img
                            className={styles.socialLogo}
                            src={INSTA}
                            alt="Instagram logo"
                        />
                    </div>
                    <FormInput fontWeight="bold" vertical={true} name="instagram" placeholder="Instargram" size="large" />
                </Col>
                <Col span={12} className={styles.socialRow}>
                    <div className={styles.socialLogoContainer}>
                        <img className={styles.socialLogo} src={TT} alt="Tiktok logo" />
                    </div>
                    <FormInput fontWeight="bold" vertical={true} name="tiktok" placeholder="Tiktok" size="large" />
                </Col>
                <Col span={12} className={styles.socialRow}>
                    <div className={styles.socialLogoContainer}>
                        <img className={styles.socialLogo} src={LINE} alt="Line logo" />
                    </div>
                    <FormInput fontWeight="bold" vertical={true} name="lineId" placeholder="Line OA" size="large" />
                </Col>
                <Col span={12} className={styles.socialRow}>
                    <div className={styles.socialLogoContainer}>
                        <img
                            className={styles.socialLogo}
                            src={INTERNET}
                            alt="Internet logo"
                        />
                    </div>
                    <FormInput fontWeight="bold" vertical={true} name="website" placeholder="Website" size="large" />
                </Col>
            </Row>
        </Space>
    )
}

export default SocialMediaInformationForEdit;